import React from "react";
import { useEffect } from "react";
import { useRef } from "react";
import "../sass/App.scss";

const Cursor = () => {
  const cursorRef = useRef(null);

  useEffect(() => {
    function mouseMove(e) {
      const { clientX, clientY } = e;
      const mouseX = clientX - cursorRef.current.clientWidth / 2;
      const mouseY = clientY - cursorRef.current.clientHeight / 2;
      cursorRef.current.style.transform = `translate3d(${mouseX}px,${mouseY}px,0)`;
    }
    document.addEventListener("mousemove", mouseMove);
    return () => {
      document.removeEventListener("mousemove", mouseMove);
    };
  }, []);
  return <div ref={cursorRef} className="custom-cursor"></div>;
};

export default Cursor;
